export let Project = {
  api: 'https://api.hoxtonmix.com/api/v3/',
  apiStaging: 'https://staging-api.hoxtonmix.com/api/v3/',

  appStore: 'https://apps.apple.com/gb/app/hoxton-mix/id6449089524',
  auth: {
    cognito: true,
  },
  chargbeeSite: 'hoxtonmix',

  chargebeeUrl: 'https://checkout.hoxtonmix.com',
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_2rhDN9Aac',
    userPoolWebClientId: '4f68p84gqg362bpuvvh8dab6',
  },
  cognitoMobile: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_2rhDN9Aac',
    userPoolWebClientId: '4f68p84gqg362bpuvvh8dab6',
  },
  cognitoMobileStaging: {
    region: 'eu-west',
    userPoolId: 'eu-west-2_keD3zW0Dd',
    userPoolWebClientId: 't9sgma6dtere3s4rd18hep7u3',
  },

  companyAPI: 'https://api.hoxtonmix.com/api/v3/',
  crisp: '708c694e-aa84-49e2-8cd3-0fb15d186d01',

  dataRelay: '1637-c53c-21bc',
  flags: {
    related_offers: true,
  },
  flagsmith: 'EuUX6f5pCYgCHDgK9vqf95',
  gtm: 'GTM-K636ZW',
  headers: {},
  locale: 'en-gb',
  logs: {
    ANALYTICS: true,
    API: false,
    STORAGE: false,
  },
  loqate: 'PR28-BF96-PB24-GY46',
  marketingSiteUrl: 'https://hoxtonmix.com/',
  mobileApp: 'hmportal',
  paypal:
    'ARLU1HFkZQXD_swGtgbR2tN7f-bFYoyYlPUL69PmwHFOioelEiSh-NxichfQuPCj05UoNAeUE0Ptz-xB',
  playStore:
    'https://play.google.com/store/apps/details?id=com.hoxtonmix.portal',
  portalUrl: 'https://account.hoxtonmix.com',
  redirectSignIn: '/auth/account-verify/',
  sentry:
    'https://7c4558361cd248d3bcdc4469f4861b32@o31090.ingest.sentry.io/4505487325265920',
  sentryEnvironment: 'production',
  siteName: 'Hoxton Mix',
  stripe: 'pk_test_CvegxsaywY0KQ1iu62m08PQx',
  testCafeStage: 'staging',
  ...(typeof projectOverrides !== 'undefined' ? projectOverrides : {}),
}
export function setProject(newProject) {
  Project = newProject
}
